(function($){

  if($('.js-product-page__size-btn')){
    function throttle(delay, callback) {
      var previousCall = new Date().getTime();
      return function() {
          var time = new Date().getTime();
          if ((time - previousCall) >= delay) {
              previousCall = time;
              callback.apply(null, arguments);
          }
      };
    }
    $('.js-product-page__size-btn').click(function(e) {
      e.preventDefault();

      // update value
      var val = $(this).data('val');
      $('.js-product-page__size-select').val(val);
      $('.js-product-page__size-select').trigger('change');

      // update button color
      $('.product-header__size-btn').removeClass('product-header__size-btn--selected');
      $(this).parent().parent().addClass('product-header__size-btn--selected');


      // update button color new and weight
      var selectedElem = this;
      var bgColor = $(this).attr('data-color-bg');
      var textColor = $(this).attr('data-color-text');
      $('.js-product-page__size-btn').each(function(idx ) {
          var qty = $(this).attr('qty');
          if ($(this).is(selectedElem)) {
              $(this).children(":first").removeClass('bg-white text-black text-gray').css({'background-color':bgColor,'color':textColor});
              $(this).removeClass("before:bg-black bg-white before:bg-black text-black text-gray border-gray").css({'background-color':bgColor,'border':'1px solid '+bgColor,'color':textColor});
              if (qty == "0") {
                  $(this).addClass("before:absolute before:left-1/2 before:content-[''] before:w-px before:h-[141%] before:bg-current before:rotate-45")
              } else {
                  $(this).removeClass("before:bg-current before:absolute before:left-1/2 before:content-[''] before:w-px before:h-[141%] before:rotate-45")
              }

              // update weight
              if (typeof productWeights !== 'undefined' && productWeights) {
                  var weight = (idx < productWeights.length ? productWeights[idx] : productWeights[0]);
                  $('.js-product-weight').first().html(weight + 'g');
                  $('.js-product-weight').first().data('highlight', weight + 'g');
                  $('.js-product-weight').first().data('size', $(this).data('val'));
              }

          } else {
              if (qty == "0") {
                  $(this).children(":first").removeClass('text-black bg-black text-white').css({'background-color':'','color':''}).addClass('bg-white text-gray');
                  $(this).removeClass("before:bg-black before:bg-current bg-black text-white before:bg-black text-black border-black").css({'border':'','background-color':'', 'color':''}).addClass("before:absolute before:left-1/2 before:content-[''] before:w-px before:h-[141%] before:bg-current before:rotate-45 bg-white text-gray border-gray");
              } else {
                  $(this).children(":first").removeClass('bg-black text-white text-gray').css({'background-color':'','color':'#000000'}).addClass('bg-white');
                  $(this).removeClass("before:bg-black before:bg-current bg-black text-white before:absolute before:left-1/2 before:content-[''] before:w-px before:h-[141%] before:bg-black before:rotate-45 text-gray border-gray").css({'border':'','background-color':''}).addClass("text-black border-black bg-white");
              }
          }

      })

      // update one left or not.
      var qty = $(this).attr('qty');
        if (qty == "1") {
        $('#AddToCart-schedule-collection-template').text('Add to Bag - Only 1 Left');
        } else if (qty == "0") {
        $('#AddToCart-schedule-collection-template').text('Out of Stock');
        } else {
        $('#AddToCart-schedule-collection-template').text('Add to Bag');
        }
    })
    // CAROUSSEL
    var windowHeight = $(window).height();

    $(window).resize(throttle(300,function() {
        // var docViewTop = $(window).scrollTop();
        // var docViewBottom = docViewTop + $(window).height();
        windowHeight = $(window).height();
        updateCarousselsImgWidth();
    }));
    var carousselImgWidthAr = new Array();

    var currentCarousselImgAr = new Array();

    function updateCarousselsImgWidth() {
      $('.js-dotted-caroussel').each(function(i, elem) {
          var carousselId = $(elem).attr('id');
          var imgWidth = $(elem).children().first().width();
          carousselImgWidthAr[carousselId] = imgWidth;
      })
    }
    $('.js-dotted-caroussel').each(function(i, elem) {
        var carousselId = $(elem).attr('id');
        $(elem).on('scroll', throttle(300, function() {
            var imgWidth = carousselImgWidthAr[carousselId];
            var scrollPos = $(elem).scrollLeft();
            var selectedImg = Math.floor(1.5 + scrollPos / imgWidth);
            if (selectedImg != currentCarousselImgAr[carousselId]) {
                var dots = $('.caroussel-dots[caroussel=' + carousselId + ']').children('.caroussel-dot');
                dots.removeClass('caroussel-dot--selected');
                dots.eq(selectedImg - 1).addClass('caroussel-dot--selected');
                currentCarousselImgAr[carousselId] = selectedImg;
            }
        }))
    })

    $('.js-caroussel-dot').click(function(e) {
        e.preventDefault();
        var carouselId = $(this).parent().attr('caroussel');
        var carousel = $('#' + carouselId);
        var picPos = parseInt($(this).attr('picpos'));
        var left = picPos * $('#' + carouselId).children().first().width();
        carousel.removeClass('snap-x');
        carousel.stop().animate(
            { scrollLeft: left },
            500,
            () => carousel.addClass('snap-x')
        );
    })

    $('.js-caroussel-arrow').click(function(e) {
        e.preventDefault();
        var carouselId = $(this).attr('caroussel');
        var carousel = $('#' + carouselId);
        var dir = $(this).attr('direction');
        var imgWidth = carousel.children().first().width();
        var nbImages = carousel.children().length;
        var left = carousel.scrollLeft();
        if (dir == 'left')
            left -= imgWidth;
        else
            left += imgWidth;

        maxLeft = imgWidth * (nbImages - 1);

        if (left < -10) // -10 is a margin. 0 should be ok but is not in all situations. Anyway, no pic we use is narrower than 10px
            left = maxLeft;
        else if (left > maxLeft)
            left = 0;

        carousel.removeClass('snap-x');
        carousel.stop().animate(
            { scrollLeft: left },
            500,
            () => carousel.addClass('snap-x')
        );


    })

    updateCarousselsImgWidth();

  }

  function hokaSlider(){
    $('.slick--hoka').slick({
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      mobileFirst: true,
      infinite: false,
      prevArrow: $('.slick--hoka-arrow-prev'),
      nextArrow: $('.slick--hoka-arrow-next'),
      responsive:[{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
        }
      }]
    });
  }

  function rockerSlider(){
    $('.slick--rocker').slick({
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      mobileFirst: true,
      infinite: true,
      touchThreshold: 20,
      autoplay: false,
      autoplaySpeed: 7000
    });
  }

  $(window).on("load", function(){
    if ($('.slick--hoka').length) {
      hokaSlider();
    }

    if ($('.slick--rocker').length) {
      rockerSlider()
      let observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            $('.slick--rocker').slick('slickPlay'); // Start autoplay when in viewport
            $('.slick--rocker').removeClass('slick-paused');
          } else {
            $('.slick--rocker').slick('slickPause'); // Pause when out of viewport
            $('.slick--rocker').addClass('slick-paused')
          }
        });
      }, { threshold: 0.5 });

      observer.observe($('.slick--rocker')[0]);

    }

    $('.btn--colorway-toggle').on('click', function(e) {
      let mafateImg = $('.js-hoka-tech img');
      let colorToggle = $('.colorway-toggle')
      let colorAlt = colorToggle.data('color-alt');
      let color = colorToggle.data('color');
      if(colorToggle.hasClass('justify-start')){
        colorToggle.children().css('background-color',colorAlt);
        colorToggle.toggleClass('justify-start');
        colorToggle.toggleClass('justify-end');
        mafateImg.toggleClass('hidden')
        $('.slick--hoka').slick('slickGoTo','1')
      }else{
        colorToggle.children().css('background-color',color);
        colorToggle.toggleClass('justify-start');
        colorToggle.toggleClass('justify-end');
        mafateImg.toggleClass('hidden')
        $('.slick--hoka').slick('slickGoTo','0')
      }
    });
  });

  function initProductHighlightEvents() {
    $('.js-product-highlight').click(function(e) {

      e.preventDefault();
      e.stopPropagation();

      let highlight =  $(this).data('highlight'),
          desc,
          unit,
          displayWeight;

      if ($(this).data('type') == 'weight') {
          unit = $(this).data('type-unit');
          displayWeight = highlight;
      }

      if (unit == 'g') {
          displayWeight = highlight.replace('g', ' ' + theme.strings.product.grams);
      } else {
          displayWeight = highlight.replace(unit, ' ' + unit);
      }

      let size = $(this).data('size');
      // Map numeric size to label

      const sizeLabels = ["XS", "S", "M", "L", "XL"];
      if (size !== "One Size") {
          let sizeIndex = parseInt(String(size).replace("Size ", ""), 10);
          if (!isNaN(sizeIndex) && sizeIndex >= 0 && sizeIndex < sizeLabels.length) {
              size = sizeLabels[sizeIndex];
          }
      }

      if (size === "One Size") {
          desc = theme.strings.product.weightDescriptionSingleSize
              .replace('{{weight}}', displayWeight);
      } else if (size) {
          desc = theme.strings.product.weightDescription
              .replace('{{weight}}', displayWeight)
              .replace('{{size}}', String(size).replace('Size ', ''));
      } else {
          desc = productHighlightDescs[highlight];
      }


      $('#highlight-box__highlight').html(highlight);
      $('#highlight-box__desc').html(desc);
      // other highlights
      var isFirst = true;
      $('#highlight-box__other').html('');
      $('.js-product-highlight').each(function(e) {
          var otherHighlight = $(this).data('highlight');
          var size = $(this).data('size');
          var isHighlight = (otherHighlight == highlight);
          var isWeight = ($(this).data('type') == 'weight');
          $('#highlight-box__other').append('<a '+ (isWeight ? ' data-type="weight"' : '') + (size ? ' data-size="' + size + '"' : '') + ' data-highlight="' + otherHighlight + '" class="js-product-highlight ' + (isFirst ? '' : 'ml-3') + ' cursor-pointer inline-block mx-0 font-simon text-btn2 h-[34px] px-4 py-2.5 rounded-[50px] border border-black text-center mb-2 md:text-btn2-d hover:bg-black hover:text-white ' + (isHighlight ? 'bg-black text-white' : '') + '">' + otherHighlight + '</a>');
          if (isFirst)
              isFirst = false;
      })
      $('#highlight-box-bkg').removeClass('hidden').addClass('flex');
      $('.js-product-highlight').off();
      $('#hightlight-box__close').off();
      $('#highlight-box-bkg').off();
      initProductHighlightEvents();
    })
    $('#hightlight-box__close, #highlight-box-bkg').click(function(e) {
      e.preventDefault();
      $('#highlight-box-bkg').removeClass('flex').addClass('hidden');
    })
  }
  initProductHighlightEvents();

  function initHighlightEvents() {
    $('.js-event-highlight').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var highlight =  $(this).data('highlight');

      var desc = eventHighlightDescs[highlight];
          if (!desc)
              return true;
      var descA = desc.split('\n');
      var descB = descA.join(" <br> ");
      if  (descB.includes('*stravalink*')){
        descB = descB.replace('*stravalink*','<a href="https://www.strava.com/clubs/537488/group_events/1754247?new=true" target="_blank" class="underline">here</a>')
      }else if(descB.includes('*maurtenlink*')){
        descB = descB.replace('*maurtenlink*','<a href="https://satisfyrunning.typeform.com/to/fqbc3tRW" target="_blank" class="underline">here</a>')
      }else if(descB.includes('*partylink*')){
        descB = descB.replace('*partylink*','<a href="https://satisfyrunning.typeform.com/to/kbyXX1Tc" target="_blank" class="underline">here</a>')
      }else if(descB.includes('*berlinstravalink*')){
        descB = descB.replace('*berlinstravalink*','<a href="https://www.strava.com/clubs/537488/group_events/1784034?_branch_match_id=1279023520934019722&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXLy4pSixL1EssKNDLyczL1vcJdXPyC7H0ifJNsq8rSk1LLSrKzEuPTyrKLy9OLbJ1zijKz00FAH6GZE49AAAA" target="_blank" class="underline">here</a>')
      }
      $('#eventHighlight-box__highlight').html(highlight);
      $('#eventHighlight-box__desc').html(descB);
      // other highlights
      var isFirst = true;
      $('#eventHighlight-box-bkg').removeClass('hidden').addClass('flex');
      $('.js-event-highlight').off();
      $('#eventHighlight-box__close').off();
      $('#eventHighlight-box-bkg').off();
      initHighlightEvents();
    })
    $('.eventHighlight-box__close').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      $('#eventHighlight-box-bkg').removeClass('flex').addClass('hidden');
    })
  }

  initHighlightEvents();

})(jQuery);

// $('.days-list button').on('click', function(t){
//   let event = $(this).data('day');
//   let customColor = false;
//   if ($('.days-list button.active').hasClass('text-custom-col-color')){
//     customColor = true;
//   }
//   $('.days-list button.active').removeClass('bg-current text-white text-custom-col-color pointer-events-none')
//   $('.days-list button.active').addClass('bg-custom-col-color text-current sm:hover:opactiy-60')
//   $('.days-list button.active').removeClass('active')
//   $(this).removeClass('bg-custom-col-color text-current sm:hover:opactiy-60')
//   $(this).addClass('active bg-current text-custom-col-color pointer-events-none')

//   $('.events-list div.active').addClass('hidden').removeClass('active')
//   $('.events-list div[data-events="'+event+'"]').addClass('active').removeClass('hidden')
// })

document.querySelectorAll('.days-list button') ? document.querySelectorAll('.days-list button').forEach(day => {
  day.addEventListener('click', function(){

    let event = day.dataset.day;
    let customColor = false;

    if (document.querySelector('.days-list button.active > span').classList.contains('text-custom-col-color')){
      customColor = true;
    }

    let activeButton = document.querySelector('.days-list button.active');
    let activeText = document.querySelector('.days-list button.active span');
    
    activeButton.classList.remove('bg-current', 'pointer-events-none');
    activeButton.classList.add('bg-custom-col-color', 'sm:hover:opacity-60');
    activeText.classList.remove('text-white', 'text-custom-col-color');
    activeText.classList.add('text-current', 'sm:hover:opacity-60');
    activeButton.classList.remove('active');
    
    day.classList.remove('bg-custom-col-color','sm:hover:opacity-60')
    day.classList.add('active', 'bg-current', 'pointer-events-none')
    day.querySelector('span').classList.remove('text-current')
    if(customColor){
      day.querySelector('span').classList.add('text-custom-col-color')
    }else{
      day.querySelector('span').classList.add('text-white')
    }

    document.querySelector('.events-list div.active').classList.add('hidden')
    document.querySelector('.events-list div.active').classList.remove('active')
    document.querySelector('.events-list div[data-events="'+event+'"]').classList.add('active')
    document.querySelector('.events-list div[data-events="'+event+'"]').classList.remove('hidden')
  })
 }) : '';

// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player;
let videoId = document.getElementById('dropVideo') ? document.getElementById('dropVideo').dataset.id : '';
function onYouTubeIframeAPIReady() {
  player = new YT.Player('dropVideo', {
    height: '2000',
    width: '1000',
    videoId: videoId,
    playerVars: {
      'playsinline': 1,
      'autoplay': 1,
      'mute': 1,
      'controls': 0,
      'rel': 0,
      'loop': 1,
      'playlist': videoId,
      'showinfo': 0,
      'iv_load_policy': 3,
      'origin': 'https://satisfyrunning.com/',
      'vq': 'hd1080'
    },
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange,
    }
  });
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
  event.target.playVideo();
  player.setPlaybackQuality('hd1080')
  event.target.setPlaybackQuality('hd1080')
  document.querySelector('.hoka-video--poster').classList.add('hidden')
}

// 5. The API calls this function when the player's state changes.
function onPlayerStateChange(event) {

  event.target.setPlaybackQuality('hd1080')
  player.setPlaybackQuality('hd1080')

}

function updateSwatch(swatch){
  let urlT = document.querySelector('.js-swatch-url');
  let colorNameT = document.querySelector('.js-swatch-color-name');
  let imgT = document.querySelector('.js-swatch-p-img');
  let lookT = document.querySelector('.js-look-img');
  let lookSourceT = document.querySelector('.js-look-source');
  let url = swatch.dataset.url;
  let colorName = swatch.dataset.color;
  let img = swatch.dataset.img;
  let look = swatch.dataset.look;
  colorNameT.innerHTML = colorName;
  document.querySelectorAll('.js-look-swatch').forEach(item => {
    item.classList.remove('bg-gray');
  });
  document.querySelectorAll('.js-look-swatch span').forEach(item => {
    item.classList.remove('w-2.5','h-2.5');
    item.classList.add('w-full','h-full');
  });
  swatch.classList.add('bg-gray');
  swatch.querySelector('span').classList.remove('w-full','h-full');
  swatch.querySelector('span').classList.add('w-2.5','h-2.5');
  document.querySelectorAll('.js-swatch-url').forEach(item => {
    item.href = url;
  });
  urlT.href = url;
  imgT.src = `//satisfyrunning.com/cdn/shop/${img}?crop=center&v=1736513161&width=351`;
  imgT.srcset = `
      //satisfyrunning.com/cdn/shop/${img}?crop=center&v=1736513161&width=351 351w,
      //satisfyrunning.com/cdn/shop/${img}?crop=center&v=1736513161&width=702 702w,
      //satisfyrunning.com/cdn/shop/${img}?crop=center&v=1736513161&width=1053 1053w,
      //satisfyrunning.com/cdn/shop/${img}?crop=center&v=1736513161&width=1404 1404w
  `;
  lookT.src = `//satisfyrunning.com/cdn/shop/files/${look}?v=1738734261&width=2000`;
  lookT.srcset = `
      //satisfyrunning.com/cdn/shop/files/${look}?v=1738734261&width=1000 1000w,
      //satisfyrunning.com/cdn/shop/files/${look}?v=1738734261&width=2000 2000w
  `;
  lookSourceT.srcset = `
      //satisfyrunning.com/cdn/shop/files/${look}?v=1738734261&width=1000 1000w,
      //satisfyrunning.com/cdn/shop/files/${look}?v=1738734261&width=2000 2000w
  `;
}

document.addEventListener('DOMContentLoaded', function () {
  if(videoId && document.getElementById("toggleMute")){
    document.getElementById("toggleMute").addEventListener('click', function(event) {
      event.target.children[0].classList.toggle('hidden')
      if(videoId){
        if (player.isMuted()) {
          player.unMute();
        } else {
          player.mute();
        }
      }
    });
    
    document.getElementById("togglePlay").addEventListener('click', function(event) {
      if(videoId){
        if (player.getPlayerState() == 2) {
          player.playVideo()
          event.target.children[0].classList.toggle('hidden')
          event.target.children[1].classList.toggle('hidden')
        } else {
          player.pauseVideo()
          event.target.children[0].classList.toggle('hidden')
          event.target.children[1].classList.toggle('hidden')
        }
      }
    });

  }
  if(document.querySelector('.js-look-swatch')){
    document.querySelectorAll('.js-look-swatch').forEach(swatch => {
      swatch.addEventListener('click', function(e){
        e.preventDefault();
        updateSwatch(swatch)
      })
      swatch.addEventListener('mouseover', function(e){
        updateSwatch(swatch)
      })
    })
  }
});

if(document.querySelector('.line-specs--btn')){
  document.querySelectorAll('.line-specs--btn').forEach(btn => {
    btn.addEventListener('click', function(e){
      e.preventDefault();
      let specs = btn.dataset.specs;
      let target = document.getElementById(specs);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
      if (target.classList.contains('collapse-list--item-collapsed')){
        target.classList.toggle('collapse-list--item-collapsed');
        target.querySelector('.collapse-list--content').classList.toggle('h-0');
      }
    })
  })
}

